import React from 'react';
import { useTranslation } from 'react-i18next';

import { AcceptedBlock } from '../../Block';

export default function OfflineCard({ invoice: { data = {} } }) {
  const {
    i18n: { language },
  } = useTranslation();

  return (
    <AcceptedBlock>
      <div dangerouslySetInnerHTML={{ __html: data[language] }} />
    </AcceptedBlock>
  );
}
